import { useState, useEffect } from 'react'
import { Container, Form } from 'react-bootstrap'
import Footer from '../components/footer'
import Header from '../components/header'
import { FooterWapper } from '../components/styles/Footer.styled'
import { Card, MyButton } from '../components/styles/MyComponents.styled'
import { ContentPage } from '../components/styles/Page.styled'
import { LoadingRow } from '../components/loading-row'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { contactUs, fetchSendEmailCode, getVerifyCode } from '../api/api'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const ConractUs = () => {
    const [submitStatus, setSubmitStatus] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [verifying, setVerifying] = useState(false);
    const [sendingCode, setSendingCode] = useState(false);
    const [code, setCode] = useState('');
    const [codeError, setCodeError] = useState(false);
    const [codeErrorMessage, setCodeErrorMessage] = useState('');
    const [countdown, setCountdown] = useState(0);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        message: ''
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        if (formData.name == null || formData.name.trim() === "") {
            toast.error('Please enter your name.');
            return;
        }
        if (formData.email == null || formData.email.trim() === "") {
            toast.error('Please enter the correct email format.');
            return;
        }
        if (formData.company == null || formData.company.trim() === "") {
            toast.error('Please enter your company.');
            return;
        }
        if (formData.message == null || formData.message.trim() === "") {
            toast.error('Please enter your message.');
            return;
        }

        setShowVerifyModal(true);
        sendVerificationCode(formData.email);
    };

    const sendVerificationCode = async (email: string) => {
        setSendingCode(true);
        setCodeError(false);
        try {
            await fetchSendEmailCode(email);
            setCountdown(90);
        } catch (err: any) {
            setCodeErrorMessage(err.message || 'Failed to send code.');
            setCodeError(true);
            toast.error(err.message || 'Failed to send code.');
        } finally {
            setSendingCode(false);
        }
    };

    const handleVerifyCode = async () => {
        if (!code || code.length < 6) {
            setCodeErrorMessage('Please enter a valid verification code.');
            setCodeError(true);
            return;
        }

        setVerifying(true);
        try {
            const res = await getVerifyCode('email', formData.email, code);
            if (res?.status === '1') {
                setShowVerifyModal(false);
                submitContactForm();
            } else {
                setCodeErrorMessage('Invalid verification code.');
                setCodeError(true);
            }
        } catch (err: any) {
            setCodeErrorMessage(err.message || 'Verification failed.');
            setCodeError(true);
        } finally {
            setVerifying(false);
        }
    };

    const submitContactForm = () => {
        setLoading(true);
        contactUs(formData.name, formData.email, formData.company, formData.message).then((res) => {
            if (res.status === '1') {
                setSubmitStatus(true);
                toast.success('Submit Successfully.');
            } else {
                toast.error('Network error, please try again');
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (countdown > 0) {
            timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        }
        return () => clearTimeout(timer);
    }, [countdown]);

    return (
        <FooterWapper>
            <Header />
            <ContentPage>
                <Container>
                    <h1>Contact Us</h1>
                    <h2>Our team is happy to answer your questions. Fill out the form and we'll be in touch as soon as possible</h2>

                    <Card >
                        {!submitStatus && !loading && (
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Your Name</Form.Label>
                                    <Form.Control 
                                        type='text' 
                                        name='name' 
                                        value={formData.name}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control 
                                        type='email' 
                                        name='email' 
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Company</Form.Label>
                                    <Form.Control 
                                        type='text' 
                                        name='company' 
                                        value={formData.company}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control 
                                        as="textarea" 
                                        name='message' 
                                        value={formData.message}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>

                                <div className='d-flex justify-content-center mt-5'>
                                    <MyButton type='submit'>Submit</MyButton>
                                </div>
                            </Form>
                        )}
                        
                        {loading && <LoadingRow />}
                        
                        {submitStatus && (
                            <div style={{ minHeight: 300 }} className='d-flex justify-content-center align-items-center gap-3'>
                                <FontAwesomeIcon icon='check-circle' style={{ color: '#89cb6d', height: 30,width:30 }} />
                                <div>
                                    <div className='mb-3' style={{ fontSize: 20 }}>Submit Successfully.</div>
                                    <div style={{ fontSize: 20 }}>We will contact you ASAP.</div>
                                </div>
                            </div>
                        )}
                    </Card>
                </Container>
            </ContentPage>

            {/* Verification Modal */}
            <Modal show={showVerifyModal} onHide={() => setShowVerifyModal(false)} centered>
                <Modal.Header>
                    <Modal.Title>Email Verification</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>We sent code to <strong>{formData.email}</strong>.</p>
                    <div className="mt-3">
                        <Form.Label>Two-Step Verification</Form.Label>
                        <div className="d-flex flex-column flex-md-row gap-2">
                            <Form.Control
                                type="text"
                                placeholder="Enter verification code..."
                                value={code}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        setCodeError(false);
                                    }
                                    setCode(e.target.value);
                                }}
                                disabled={verifying}
                                maxLength={6}
                                className="flex-grow-1"
                            />
                            <Button
                                variant="primary"
                                disabled={countdown > 0 || sendingCode}
                                onClick={() => sendVerificationCode(formData.email)}
                                className="flex-shrink-0"
                                style={{ whiteSpace: 'nowrap',color: 'white' }}
                            >
                                {sendingCode ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-1"></span>
                                        Sending
                                    </>
                                ) : countdown > 0 ? (
                                    `${countdown}s`
                                ) : (
                                    'Resend Code'
                                )}
                            </Button>
                        </div>
                        {codeError && (
                            <div className="text-danger mt-2">
                                {codeErrorMessage}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button 
                        variant="primary" 
                        onClick={handleVerifyCode}
                        disabled={verifying}
                        className="w-100"
                        style={{ color: 'white' }}
                    >
                        {verifying ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Verifying...
                            </>
                        ) : (
                            'Verify & Submit'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer />
        </FooterWapper>
    )
}